import { Button, Loader, Menu } from "@mantine/core";
import { IconChevronDown, IconDotsVertical, IconGavel, IconMessage } from "@tabler/icons-react";
import { NO_AUTHORIZATION_CODE } from "../../../utils/forum-rules";
import { useConfigContext } from "../../../contexts/ConfigContext/ConfigContextProvider";

export default function ForumHeaderButtonsMobile({ handleToggleFilter, isDecrecent, getDiscussionThemes, setIsModal, state }) {


   const { jsonTexts } = useConfigContext()
   const texts = jsonTexts?.foro?.headerFilters

   return (
      <div className='ForoPageHeader--mobile-container'>

         <Button color='var(--color-secondary)' onClick={handleToggleFilter} w={'max-content'} >
            < IconChevronDown className='ForoPageHeader-button--icon' />
            <span className='ForoPageHeader-button--text'>
               {isDecrecent ? texts?.latestArticlesButtonText : texts?.oldestArticlesButtonText}
            </span>
         </Button>

         <Menu shadow="md" width={200}>
            <Menu.Target>
               < IconDotsVertical size={30} />
            </Menu.Target>

            <Menu.Dropdown>

               <Menu.Label>{texts?.mobile?.createNewDiscussion}</Menu.Label>
               <Menu.Item leftSection={< IconMessage className='ForoPageHeader-button--icon' />} onClick={state.error.status === NO_AUTHORIZATION_CODE ? null : () => getDiscussionThemes()}>
                  <span className='ForoPageHeader-button--text'openRulesMenuButtonText >
                     {state.isLoading ? < Loader size={20} color="var(--color-base-ligth)" /> : texts?.createNewDiscussion}
                  </span>
               </Menu.Item>

               <Menu.Divider />

               <Menu.Label>{texts?.mobile?.openRulesMenuButtonText}</Menu.Label>
               <Menu.Item leftSection={< IconGavel className='ForoPageHeader-button--icon' />} onClick={() => setIsModal(true)} >
                  <span className='ForoPageHeader-button--text'>
                     {texts?.openRulesModalButtonText}
                  </span>
               </Menu.Item>

            </Menu.Dropdown>

         </Menu>
      </div>
   )
}
